export default __webpack_public_path__ + "static/media/bg-pick-left.7e0c4015.png";